export const USER_MANAGEMENT_PAGE_TITLE = "Users";
export const CONVERSATION_MANAGEMENT_PAGE_TITLE = "Conversations";
export const DATASET_MANAGEMENT_PAGE_TITLE = "Datasets";
export const DATASET_DETAIL_PAGE_TITLE = "Dataset Admin";
export const TABLE_MANAGEMENT_PAGE_TITLE = "Tables";
